import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import MaterialUIDialog from '@material-ui/core/Dialog';
import MaterialUIDialogTitle from '@material-ui/core/DialogTitle';
import MaterialUIDialogContent from '@material-ui/core/DialogContent';
import MaterialUIDialogActions from '@material-ui/core/DialogActions';

const styles = {
  dialogActions: {
    justifyContent: 'space-between',
  },
  dialogContent: {
    overflow: 'scroll',
    borderRadius: props => props.borderRadius,
  },
  scrollVisible: {
    overflow: 'visible',
  },
};


const DialogActions = withStyles(styles)(props => (
  <MaterialUIDialogActions
    {...props}
    className={props.classes.dialogActions}
  />
));

const DialogContent = withStyles(styles)(props => (
  <MaterialUIDialogContent
    {...props}
    className={props.classes.dialogActions}
  />
));

const Dialog = ({
  classes,
  dialogOverflowVisible,
  ...rest
}) => (
  <MaterialUIDialog
    classes={{ paperScrollPaper: [classes.dialogContent, dialogOverflowVisible ? classes.scrollVisible : null].join(' ').trim() }}
    {...rest}
  />
);

Dialog.propTypes = {
  classes: PropTypes.object.isRequired,
  children: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.arrayOf(PropTypes.object),
  ]).isRequired,
  dialogOverflowVisible: PropTypes.bool,
};

Dialog.defaultProps = {
  dialogOverflowVisible: false,
};

Dialog.DialogTitle = MaterialUIDialogTitle;
Dialog.DialogContent = DialogContent;
Dialog.DialogActions = DialogActions;

export default withStyles(styles)(Dialog);

